import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { ContentBox } from './MultiGrid/demo/ContentBox';
import AutoSizer from './MultiGrid/AutoSizer/AutoSizer';
import MultiGrid from './MultiGrid/MultiGrid';

const STYLE_BOTTOM_LEFT_GRID = {
  overflow: 'hidden',
};
const STYLE_TOP_LEFT_GRID = {
  fontWeight: 'bold',
};
const STYLE_TOP_RIGHT_GRID = {
  fontWeight: 'bold',
};

export class PerformanceMetricsVirtualizedTable extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      fixedColumnCount: 1,
      fixedRowCount: 1,
      scrollToColumn: 0,
      scrollToRow: 0,
      CurrentWorkDay: [],
      CurrentWorkDayMU: [],
      CurrentWorkDayAgent: [],
      CurrentWorkDayAgentLookup: {},
      CurrentWorkDayTeamLookup: {},
      CurrentWorkDayMULookup: {},
      CurrentWorkDayTeam: [],
      PreviousWorkDayMU: [],
      PreviousWorkDayAgent: [],
      PreviousWorkDayTeam: [],
      ThirtyDayAverageMU: [],
      ThirtyDayAverageAgent: [],
      ThirtyDayAverageTeam: [],
      viewScorecard: false,
      sort: ''
    };

    this.topLeftHeaderCellRenderer = this.topLeftHeaderCellRenderer.bind(this);
    this.cellRendererWithHeaders = this.cellRendererWithHeaders.bind(this);
    this.columnHeaderCellRenderer = this.columnHeaderCellRenderer.bind(this);
    this.sortAsc = this.sortAsc.bind(this);
    this.sortDesc = this.sortDesc.bind(this);
    this.formatGridCellValue = this.formatGridCellValue.bind(this);
    this.setSortingLocalStorage = this.setSortingLocalStorage.bind(this);
  }

  componentWillReceiveProps(nextProps){
    let { currentTabSelectedData } = this.props;
    let stateItems = {}

    if(this.props[currentTabSelectedData] !== nextProps[currentTabSelectedData]) {

      // logic to retain current sorting on refresh or streaming data
      let sortKey = 'Name';
      let sortDirection = 'asc';
      if(localStorage.sort !== undefined) {
        sortKey = JSON.parse(localStorage.getItem('sort'));
        if(sortKey[currentTabSelectedData]) {
          sortKey = sortKey[currentTabSelectedData].toString().split("-");
          sortDirection = sortKey.pop();
          this.setState({ sort: sortKey+'-'+sortDirection });
        } else {
          sortKey = 'Name';
        }
      } else {
        this.setState({ sort: '' });
      }

      //real time data
      if(currentTabSelectedData.indexOf("Current") !== -1) {
        
        //current day date received in the following format. it is using agent/team/mu as the key, and the value is the card metrics
        //[{"241": {c: 1, d: 2, e:4}}, {{"2543": {c: 1, d: 2, e:4}}}]
        if(nextProps[currentTabSelectedData] && nextProps[currentTabSelectedData].isUpsert && nextProps[currentTabSelectedData].isUpsert === true) {
          
          //grab the current saved items
          stateItems = this.state[currentTabSelectedData + "Lookup"];

           //iterate through each item that has been updated
          Object.keys(nextProps[currentTabSelectedData].uiModelData).forEach(function(x, y) {

            //look for the item in the current state. if found, replace with updated item
            if(stateItems && stateItems[x.toString()]) {
              stateItems[x.toString()] = nextProps[currentTabSelectedData].uiModelData[x.toString()];
            }
          });
        }
        else {
          //re construct state from nextProps (this call is coming from clicking the apply filter)
          stateItems = nextProps[currentTabSelectedData].uiModelData;
        }
        
        //construct array in the format table needs
        let _formattedTableData = [];
        if(stateItems) {
          Object.keys(stateItems).forEach(function(x, y) {
              let obj = stateItems[x.toString()];
              if(obj !== undefined && obj !== null) {
                _formattedTableData.push(stateItems[x.toString()]);
              }
          });
        }

        //save data in key-lookup-form, for next iteration
        this.setState({ [currentTabSelectedData + "Lookup"]: stateItems });        

        //save state of items with table formatted array
        this.setState({ [currentTabSelectedData]: _formattedTableData.sort(sortLocalStorage) });
      }
      //for all other cases other than current day
      else {
        this.setState({ [currentTabSelectedData]: nextProps[currentTabSelectedData].sort(sortLocalStorage) });
        // this.setState({ [currentTabSelectedData]: nextProps[currentTabSelectedData] });
      }
      function sortLocalStorage(a,b) {
        let itemA = a[sortKey].toString().toUpperCase().replace(/,/g, '');
        let itemB = b[sortKey].toString().toUpperCase().replace(/,/g, '');
        if(sortDirection === 'asc') {
          if(sortKey === "Name") {
            if (itemA < itemB)
              return -1 
            if (itemA > itemB)
              return 1
            return 0
          } else {
            return itemA-itemB;
          }
        } else {
          if(sortKey === "Name") {
            if (itemB < itemA)
              return -1 
            if (itemB > itemA)
              return 1
            return 0
          } else {
            return itemB-itemA;
          }
        }
      }
    }
  }

  sortAsc(column, dataToBeSorted, currentTabSelectedData) {
    if(dataToBeSorted && dataToBeSorted.length > 0) {
      dataToBeSorted.sort(function(a,b) {      
        let itemA = a[column].toString().replace(/,/g, '');
        let itemB = b[column].toString().replace(/,/g, '');
        return itemA-itemB;
      });
      
      this.setState({ sort: column+'-asc' }, function () {
        this.setSortingLocalStorage(currentTabSelectedData);
      });
    } 
  }
  
  sortDesc(column, dataToBeSorted, currentTabSelectedData) {
    if(dataToBeSorted && dataToBeSorted.length > 0) { 
      dataToBeSorted.sort(function(a,b) {      
        let itemA = a[column].toString().replace(/,/g, '');
        let itemB = b[column].toString().replace(/,/g, '');
        return itemB-itemA;
      });

      this.setState({ sort: column+'-desc' }, function () {
        this.setSortingLocalStorage(currentTabSelectedData);
      });
    }
  }

  setSortingLocalStorage(currentTabSelectedData) {
    let sortedColumns = {
      currentTabSelectedData: this.state.sort
    }
    if(localStorage.sort !== "") {
      let existing = localStorage.getItem('sort');
      existing = existing ? JSON.parse(existing) : {};
      existing[currentTabSelectedData] = this.state.sort;
      localStorage.setItem('sort', JSON.stringify(existing));
    } else {
      localStorage.setItem('sort', sortedColumns);
    }
  }

  render() {
    let { currentTabSelectedData, isTablet, isDarkMode } = this.props;
    let columnKey = (this.props.columns && this.props.columns.length > 0) ? this.props.columns.map(x => x.label).join('') : "";
    return (
      <div>
        { (this.state[currentTabSelectedData] && this.state[currentTabSelectedData].length > 0) ? 
        <ContentBox>
          <AutoSizer disableHeight>
            {({width}) => (
              <MultiGrid
                {...this.state}
                cellRenderer={this.cellRendererWithHeaders}
                columnCount={6}
                enableFixedColumnScroll
                enableFixedRowScroll
                isDarkMode={isDarkMode}
                rowCount={this.state[currentTabSelectedData].length + 1}
                styleBottomLeftGrid={STYLE_BOTTOM_LEFT_GRID}
                styleTopLeftGrid={STYLE_TOP_LEFT_GRID}
                styleTopRightGrid={STYLE_TOP_RIGHT_GRID}
                width={width}
                hideTopRightGridScrollbar
                hideBottomLeftGridScrollbar
                columnWidth={ isTablet ? 190 : 215 }
                height={ this.state[currentTabSelectedData].length > 15 ? 715 : this.state[currentTabSelectedData].length * 56.6}
                rowHeight={45}
                tableName={this.props.tableName}
                key={ columnKey }
              />
            )}
          </AutoSizer>
        </ContentBox>
      : null }
      </div>
    );
  }

  cellRendererWithHeaders(props: GridCellProps) {    
    let rowOffset = 1;
    let columnOffset = 1;
    let rowIndex = props.rowIndex - rowOffset;
    let columnIndex = props.columnIndex - columnOffset;

    if (rowIndex < 0) {
      if (columnIndex < 0) {
        // top-left cell
        return this.topLeftHeaderCellRenderer(props);
      } else {
        // column header
        return this.columnHeaderCellRenderer(props);
      }
    } else {
      if (columnIndex < 0) {
        // row header
        return this.rowHeaderCellRenderer(props);
      } else {
        return this.gridBodyCellRenderer(props, rowOffset, columnOffset);
      }
    }
  }

  topLeftHeaderCellRenderer(props: GridCellProps) {
    const { isDarkMode, tableName } = this.props;
    const classNameMap = {
      'Management Units': `mu-svg ${isDarkMode ? '' : 'dark'}`,
      'Teams': `team-svg ${isDarkMode ? '' : 'dark'}`,
      'Agents': `agent-svg ${isDarkMode ? '' : 'dark'}`,
    }
    // We don't render anything here
    return <div key={props.key} className="row-header-tablename" style={props.style}>
      {/* add corner column header */}
      <span className={classNameMap[tableName]} style={{ width: 15, height: 13 }}/>
      {tableName}
    </div>;
  }

  columnHeaderCellRenderer(props: GridCellProps) {    
    let columnOffset = 1;
    let columnIndex = props.columnIndex - columnOffset;
    let classNames = "column-header-cell";
    let cellContent = (this.props.columns && this.props.columns.length > 0) ? this.props.columns[columnIndex].label : "";
    let cellContentPercentage = /(%)/.test(cellContent) === true ? '(%)' : "";
    let { currentTabSelectedData } = this.props;
    let column = cellContent.replace(/[^a-zA-Z0-9]/g,'');
    cellContent = cellContent.replace('(%)','');
    let dataToBeSorted = this.state[currentTabSelectedData];
       
    return <div 
            key={props.key} 
            className={classNames}
            data-column={cellContent} 
            style={props.style}
            onClick={ this.state.sort === column+'-asc' ? e => this.sortDesc(column, dataToBeSorted, currentTabSelectedData) : e => this.sortAsc(column, dataToBeSorted, currentTabSelectedData)}
          >
            <div className="column__hdr-wrap" data-column={cellContent}>
              {cellContent}
              {' '}
              {cellContentPercentage}
              <div className={ this.state.sort === '' ? "arrow-svg" : this.state.sort === column+'-desc' ? "arrow-svg down" : "arrow-svg"}/>
            </div>
          </div>;
  }

  rowHeaderCellRenderer(props: GridCellProps) {
    let rowOffset = 1;
    let rowIndex = props.rowIndex - rowOffset;
    
    let { currentTabSelectedData, tableName } = this.props;
    // let gridName = tableName.replace(/\s+/g, '').slice(0, -1);
    let gridName = tableName.slice(0, -1);
    
    let itemId = this.state[currentTabSelectedData][rowIndex] ? this.state[currentTabSelectedData][rowIndex].ItemID : '';   
    let itemName = this.state[currentTabSelectedData][rowIndex] ? this.state[currentTabSelectedData][rowIndex].Name : '';
    
    return <div key={props.key} className="row-header-cell name" style={props.style} onClick={e => this.props.viewScorecard(gridName, itemId, itemName)}>
      { itemName }
    </div>;
  }

  formatGridCellValue(value, scorecardId) {
    let r = value;
    if(r === null || r === undefined) { return "-"; }

    // can add more scorecardID type else/switch statements if time and/or other number formats are needed
    if(scorecardId === 3) {
      r = Math.round(100*r)/100;
      r = r.toFixed(1);
      return r + "%";
    } else {
      r = r.toString().replace(/,/g, '');
      r = Math.round(r).toLocaleString('en');
      return r;
    } 
  }

  gridBodyCellRenderer(props: GridCellProps, rowOffset: number, columnOffset: number) { 
    const { isDarkMode } = this.state;
    const { currentTabSelectedData, scorecards } = this.props;
    const isCurrentDay = currentTabSelectedData.includes('CurrentWorkDay');
    const rowIndex = props.rowIndex - rowOffset;
    const columnIndex = props.columnIndex - columnOffset + 1;
    //Field value
    const itemValue = Object.values(this.state[currentTabSelectedData][rowIndex])[columnIndex];    
    //Field name
    let scorecardId = Object.keys(this.state[currentTabSelectedData][rowIndex])[columnIndex];
    scorecardId = scorecards ? scorecards.find(o => o.scorecardKey === scorecardId) : undefined;
    const scorecardTypeId = scorecardId ? scorecardId.scorecardTypeId : undefined;
    const formattedCellValue = this.formatGridCellValue(itemValue, scorecardTypeId);

    const dayOverDay = isCurrentDay
      && scorecardId
      && scorecardId.scorecardKey
      && !Number.isNaN(this.state[currentTabSelectedData][rowIndex][`${scorecardId.scorecardKey}DOD`])
        ? this.state[currentTabSelectedData][rowIndex][`${scorecardId.scorecardKey}DOD`]
        : null;
    
    const showDOD = isCurrentDay && !Number.isNaN(Math.round(dayOverDay));
    const isIncrease = showDOD && dayOverDay > 0;
    const red = isDarkMode ? '#ff377f' : '#ff584d';
    const green = isDarkMode ? '#11E981' : '#11d06b';
       
    return (
      <div key={props.key} className="row-header-cell body" style={props.style}>
        <div className="cell-value">
          {formattedCellValue}
          {showDOD && (
            <span className={isIncrease ? 'green-triangle-svg' : 'red-triangle-svg'} />
          )}
        </div>
        {showDOD && (
          <div className="dod">
            <span style={{ color: isIncrease ? green : red}}>{isIncrease ? '+' : ''}{Math.round(dayOverDay)}%</span>
            {' '}
            Day Over Day
          </div>
        )}
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    isTablet: state.common.isTablet,
    CurrentWorkDayMU: state.scorecard.currentWorkDayDataMU,
    CurrentWorkDayAgent: state.scorecard.currentWorkDayDataAgent,
    CurrentWorkDayTeam: state.scorecard.currentWorkDayDataTeam,
    PreviousWorkDayMU: state.scorecard.previousWorkDayDataMU,
    PreviousWorkDayAgent: state.scorecard.previousWorkDayDataAgent,
    PreviousWorkDayTeam: state.scorecard.previousWorkDayDataTeam,
    ThirtyDayAverageMU: state.scorecard.thirtyDayAverageDataMU,
    ThirtyDayAverageAgent: state.scorecard.thirtyDayAverageDataAgent,
    ThirtyDayAverageTeam: state.scorecard.thirtyDayAverageDataTeam,
    isDarkMode: state.common.isDarkMode,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PerformanceMetricsVirtualizedTable);



// WEBPACK FOOTER //
// ./src/features/scorecard/PerformanceMetricsVirtualizedTable.js